import { render } from "./NewReturnPurchase.vue?vue&type=template&id=89320292"
import script from "./NewReturnPurchase.vue?vue&type=script&lang=js"
export * from "./NewReturnPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__